module.exports = __webpack_public_path__ + "img/custom.00a198a2.png";